module.exports = "<h2>\r\n  Página não encontrada!\r\n</h2>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/not-found/not-found.component.html
// module id = ./src/app/components/home/not-found/not-found.component.html
// module chunks = main